export const graphNames = Object.freeze({
  aups: "aups",
  bfg: "bfg",
  notifications: "notifications",
  local: "local",
});
